import { useState } from 'react';

const initGraph = {
  labels: [],
  datasets: [],
};

export const useProtesisIniciadoAutorizadoDona = ({ mensualList, anualList }) => {
  const [datosAnualesDona, setDatosAnualesDona] = useState(initGraph);
  const [datosMensualesPendientesPorCategoriaDona, setDatosMensualesPendientesPorCategoriaDona] =
    useState(initGraph);
  const [datosMensualesDona, setDatosMensualesDona] = useState(initGraph);

  const getDatosMensualesPendientesPorCategoriaDona = () => {
    const { demora_0_3_dias, demora_4_7_dias, demora_mas_7_dias } = mensualList.reduce(
      (acc, item) => {
        acc.demora_0_3_dias += item.demora_0_3_dias;
        acc.demora_4_7_dias += item.demora_4_7_dias;
        acc.demora_mas_7_dias += item.demora_mas_7_dias;
        return acc;
      },
      { demora_0_3_dias: 0, demora_4_7_dias: 0, demora_mas_7_dias: 0 },
    );

    const data = {
      labels: ['0-3 días', '4-7 días', 'Más de 7 días'],
      datasets: [
        {
          label: 'Cantidad',
          data: [demora_0_3_dias, demora_4_7_dias, demora_mas_7_dias],
          backgroundColor: [
            'rgba(76, 175, 80, 0.9)',
            'rgba(255, 193, 7, 0.9)',
            'rgba(235, 53, 53, 0.9)',
          ],
          borderWidth: 0, // sin borde
        },
      ],
    };

    setDatosMensualesPendientesPorCategoriaDona(data);
  };

  const getDatosAnualesDona = () => {
    const labels = ['Pendientes', 'Autorizadas'];

    const dataValuesIniciadas = anualList.reduce((acc, item) => acc + item.cantidad_pendientes, 0);
    const dataValuesAutorizados = anualList.reduce(
      (acc, item) => acc + item.cantidad_autorizados,
      0,
    );

    const data = {
      labels,
      datasets: [
        {
          label: 'Cantidad',
          data: [dataValuesIniciadas, dataValuesAutorizados],
          backgroundColor: ['rgba(244, 139, 54, 0.9)', 'rgba(53, 223, 235, 0.9)'],
          borderWidth: 0, // sin borde
        },
      ],
    };

    setDatosAnualesDona(data);
  };

  const getDatosMensualesDona = () => {
    const labels = ['Pendientes', 'Autorizadas'];

    const dataValuesIniciadas = mensualList.reduce(
      (acc, item) => acc + item.cantidad_pendientes,
      0,
    );
    const dataValuesAutorizados = mensualList.reduce(
      (acc, item) => acc + item.cantidad_autorizados,
      0,
    );

    const data = {
      labels,
      datasets: [
        {
          label: 'Cantidad',
          data: [dataValuesIniciadas, dataValuesAutorizados],
          backgroundColor: ['rgba(244, 139, 54, 0.9)', 'rgba(53, 223, 235, 0.9)'],
          borderWidth: 0, // sin borde
        },
      ],
    };

    setDatosMensualesDona(data);
  };

  return {
    datosAnualesDona,
    datosMensualesPendientesPorCategoriaDona,
    datosMensualesDona,
    getDatosAnualesDona,
    getDatosMensualesPendientesPorCategoriaDona,
    getDatosMensualesDona,
  };
};
